module.exports = __webpack_public_path__ + "static/media/weprologontitle.828b584d.png";